/**
 * Glossary Archive
 */
(function () {
  'use strict';

  function init() {
    const menu = document.querySelector('.glossary-archive-menu');
    const sections = Array.from(document.querySelectorAll('.glossary-category-section[id]'));

    if (!menu || sections.length === 0) {
      return;
    }

    const menuLinks = Array.from(menu.querySelectorAll('a[href^="#"]:not([href="#"])'));

    if (menuLinks.length === 0) return;

    // Sticky detection
    const stickyTop = parseInt(getComputedStyle(menu).top, 10) || 100;

    function checkSticky() {
      const menuRect = menu.getBoundingClientRect();
      const isSticky = menuRect.top <= stickyTop + 2;
      menu.classList.toggle('is-sticky', isSticky);
    }

    // Create a map of section IDs to their corresponding menu links
    const linkMap = new Map();
    menuLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      const id = href.substring(1);
      if (!id) return;

      linkMap.set(id, link);
    });

    let activeId = null;

    /**
     * Set active link for a given section ID
     * @param {string} id - The section ID to activate
     */
    function setActiveLink(id) {
      if (!id || id === activeId) {
        return;
      }

      if (activeId) {
        const prevLink = linkMap.get(activeId);
        if (prevLink) {
          prevLink.classList.remove('active');
        }

        const prevSection = document.getElementById(activeId);
        if (prevSection) {
          prevSection.classList.remove('active');
        }
      }

      const nextLink = linkMap.get(id);
      if (nextLink) {
        nextLink.classList.add('active');
      }

      const nextSection = document.getElementById(id);
      if (nextSection) {
        nextSection.classList.add('active');
      }

      activeId = id;
    }

    function getMenuScrollOffset() {
      const menuTopValue = parseInt(getComputedStyle(menu).top, 10);
      const menuTop = Number.isFinite(menuTopValue) ? menuTopValue : 0;
      const menuHeight = menu.offsetHeight || 0;

      // Keep some breathing room so we activate closer to the visible title.
      return menuTop + menuHeight + 4;
    }

    function getActiveSectionIdFromScroll() {
      const targetY = window.scrollY + getMenuScrollOffset();
      let currentId = null;

      for (const section of sections) {
        if (section.offsetTop <= targetY) {
          currentId = section.id;
          continue;
        }
        break;
      }

      return currentId;
    }

    function updateActiveFromScroll() {
      const id = getActiveSectionIdFromScroll();
      if (id) {
        setActiveLink(id);
      }
    }

    let scrollRafId = null;

    function requestScrollUpdate() {
      if (scrollRafId) return;

      scrollRafId = window.requestAnimationFrame(() => {
        scrollRafId = null;
        updateActiveFromScroll();
      });
    }

    // Mobile filter toggle
    const mobileFilterToggle = document.getElementById('glossary-filter-mobile');

    menuLinks.forEach(link => {
      link.addEventListener('click', function () {
        const href = this.getAttribute('href');
        if (!href || !href.startsWith('#')) {
          return;
        }

        const id = href.substring(1);
        if (!id) {
          return;
        }

        setActiveLink(id);

        // Close mobile menu when a link is clicked
        if (mobileFilterToggle && mobileFilterToggle.checked) {
          mobileFilterToggle.checked = false;
        }
      });
    });

    function onScroll() {
      checkSticky();

      requestScrollUpdate();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      () => {
        updateActiveFromScroll();
      },
      { passive: true }
    );

    // Initial paint
    checkSticky();

    // Initial active state: prefer hash, otherwise default to the first section.
    const initialHash = window.location.hash ? window.location.hash.substring(1) : '';
    if (initialHash && linkMap.has(initialHash) && document.getElementById(initialHash)) {
      setActiveLink(initialHash);
    } else if (sections[0] && sections[0].id) {
      setActiveLink(sections[0].id);
    }

    updateActiveFromScroll();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
